
import Component from "vue-class-component"
import AbstractPage from "@/report/pages/AbstractPage.vue"
import BiSectionPage from "@/report/pages/BiSectionPage.vue"

@Component({name: "InvestmentPage", components: {BiSectionPage}})
export default class InvestmentPage extends AbstractPage {}
